import type { PaymentProtectionFeatureConfig } from '../../../types/insurances/PaymentProtectionFeatureConfig';

export const paymentProtection: PaymentProtectionFeatureConfig = {
    overview: {
        details: {
            fallbackAssistancePhonesKey: 'RO',
            fallbackAssistanceEmailsKey: 'RO',
        },
    },
    settings: {
        details: {
            showStatus: true,
        },
    },
};
